import React, { useEffect, useMemo, useCallback, useState, useRef } from "react";
import Map from "../../../../components/molecules/Map/Map";
import L from 'leaflet'
import markerCmionIcon from '../../../../components/molecules/Map/assets/camion.png'
import { Marker, Polyline, Popup } from "react-leaflet";

import { getPosicionUnidades, getUnidades } from "./integracionPanel";

import CentrarMapa from "../CentrarMapa";

// DEFINICIONES FUERA DEL COMPONENTE (Mínimo re-cálculo)
const POLLING_INTERVAL = 2000; // 5 segundos para actualizar posiciones

const markerUnidadIcono = new L.Icon({
    iconUrl: markerCmionIcon,
    iconSize: [50, 25],
    iconAnchor: [25, 12],
    popupAnchor: [0, -12],
});

// Marcador especial para unidades seleccionadas en vista de unidades
const markerUnidadSeleccionadoUnidades = new L.Icon({
    iconUrl: markerCmionIcon,
    iconSize: [50, 25],
    iconAnchor: [25, 12],
    popupAnchor: [0, -12],
    className: 'marker-units-view' // Solo la clase de vista de unidades, sin selected-highlight
});

const PanelMapaVistaUnidad = ({
    setDataUnidad,
    dataUnidad,
    unidadSeleccionada,
    centrarUnidad,
    setUnidadSeleccionada,
    listaRutasPanelIzquierdoUnidad,
    setDataUnidadVistaUnidad,
    setUnidadCoordenadas,
    dataUnidadVistaUnidad,
    unidadCoordenadas
}) => {
    // Estados principales
    const [defaultCenter] = useState({ lat: 20.67129241646564, lng: -103.35232101509537 });
    const [zoom, setZoom] = useState(13);
    const [previousZoom, setPreviousZoom] = useState(13);
    const [coordenadasVistaUnidades, setCoordenadasVistaUnidades] = useState([]);

    // Referencias para timeouts - IGUAL QUE EN SERVICIOS
    const zoomTimeoutRef = useRef(null);
    const centeringTimeoutRef = useRef(null);
    const mapRef = useRef(null);



    // Detectar cambios en el zoom para desactivar transiciones - IGUAL QUE EN SERVICIOS
    useEffect(() => {
        if (zoom !== previousZoom) {
            const mapContainer = document.querySelector('.map-container');
            if (mapContainer) {
                mapContainer.classList.add('zoom-in-progress');
                console.log(`🔍 Zoom cambió de ${previousZoom} a ${zoom} - Transiciones desactivadas (Vista Unidades)`);

                // Reactivar transiciones después de un momento
                setTimeout(() => {
                    mapContainer.classList.remove('zoom-in-progress');

                }, 800);
            }
            setPreviousZoom(zoom);
        }
    }, [zoom, previousZoom]);

    // Hook para manejar eventos de zoom del mapa - IGUAL QUE EN SERVICIOS
    useEffect(() => {
        const handleZoomEvents = () => {
            const mapContainer = document.querySelector('.map-container');
            if (!mapContainer) return;

            const leafletContainer = mapContainer.querySelector('.leaflet-container');
            if (!leafletContainer) return;

            // Función para desactivar transiciones durante zoom
            const disableTransitions = () => {
                mapContainer.classList.add('zoom-in-progress');

            };

            // Función para reactivar transiciones después del zoom
            const enableTransitions = () => {
                if (zoomTimeoutRef.current) {
                    clearTimeout(zoomTimeoutRef.current);
                }

                zoomTimeoutRef.current = setTimeout(() => {
                    mapContainer.classList.remove('zoom-in-progress');

                }, 300);
            };

            // Escuchar eventos de zoom
            leafletContainer.addEventListener('wheel', disableTransitions, { passive: true });

            let zoomTimer;
            const handleZoomEnd = () => {
                clearTimeout(zoomTimer);
                zoomTimer = setTimeout(enableTransitions, 150);
            };

            leafletContainer.addEventListener('wheel', handleZoomEnd, { passive: true });

            // También escuchar clicks en los botones de zoom
            const zoomButtons = leafletContainer.querySelectorAll('.leaflet-control-zoom a');
            zoomButtons.forEach(button => {
                button.addEventListener('click', () => {
                    disableTransitions();
                    setTimeout(enableTransitions, 500);
                });
            });

            // Cleanup
            return () => {
                if (leafletContainer) {
                    leafletContainer.removeEventListener('wheel', disableTransitions);
                    leafletContainer.removeEventListener('wheel', handleZoomEnd);

                    const zoomButtons = leafletContainer.querySelectorAll('.leaflet-control-zoom a');
                    zoomButtons.forEach(button => {
                        button.removeEventListener('click', disableTransitions);
                    });
                }
                if (zoomTimeoutRef.current) {
                    clearTimeout(zoomTimeoutRef.current);
                }
            };
        };

        const timer = setTimeout(handleZoomEvents, 1000);

        return () => {
            clearTimeout(timer);
            if (zoomTimeoutRef.current) {
                clearTimeout(zoomTimeoutRef.current);
            }
        };
    }, []); // Re-ejecutar solo una vez al montar

    // Función de obtención de datos: usamos useCallback para garantizar estabilidad si se usara en otra parte
    const getPosiciones = useCallback(async (unidades) => {

        if (unidades.length > 0) {
            const id_unidades = JSON.stringify(unidades);
            try {
                const res = await getPosicionUnidades(id_unidades);

                setCoordenadasVistaUnidades(res || []);
                setUnidadCoordenadas(res || []);
            } catch (error) {
                console.error("Error al obtener posiciones:", error);
            }
        } else {

            setCoordenadasVistaUnidades([]);
            setUnidadCoordenadas([]);
        }
    }, []); // Dependencias vacías, solo usa `getPosicionUnidades` del scope global/import


    useEffect(() => {
        const unidades = listaRutasPanelIzquierdoUnidad.map(item => item.UNIDAD);

        // Ejecuta inmediatamente al montar/cambiar la lista
        getPosiciones(unidades);

        // Polling para actualizaciones periódicas (más fluido que depender de un estado)
        const intervalId = setInterval(() => {
            getPosiciones(unidades);
        }, POLLING_INTERVAL);

        // Limpieza: importante para evitar fugas de memoria y llamadas innecesarias
        return () => clearInterval(intervalId);
    }, [listaRutasPanelIzquierdoUnidad, getPosiciones]); // SÓLO si cambia la lista de unidades a seguir

    // Manejar centrado de unidad - IGUAL QUE EN SERVICIOS
    useEffect(() => {
        if (centrarUnidad && centrarUnidad.lat && centrarUnidad.lng) {


            const mapContainer = document.querySelector('.map-container');
            if (mapContainer) {
                mapContainer.classList.add('zoom-in-progress');
            }

            setZoom(16); // El zoom se establece aquí

            if (centeringTimeoutRef.current) {
                clearTimeout(centeringTimeoutRef.current);
            }

            centeringTimeoutRef.current = setTimeout(() => {
                if (mapContainer) {
                    mapContainer.classList.remove('zoom-in-progress');
                }
            }, 1500);
        }

        return () => {
            if (centeringTimeoutRef.current) {
                clearTimeout(centeringTimeoutRef.current);
            }
        };
    }, [centrarUnidad]);

    // Función de utilidad con useCallback
    const handleUnidadClick = useCallback((data) => {
        // Desactivar transiciones durante el click - IGUAL QUE EN SERVICIOS
        const mapContainer = document.querySelector('.map-container');
        if (mapContainer) {
            mapContainer.classList.add('zoom-in-progress');

            setTimeout(() => {
                mapContainer.classList.remove('zoom-in-progress');
            }, 300);
        }

        const dataUnidad = listaRutasPanelIzquierdoUnidad.find(item => item.UNIDAD === data.UNIDAD);
        setDataUnidadVistaUnidad(dataUnidad);
        setDataUnidad(data);
        setUnidadSeleccionada(null);
    }, [listaRutasPanelIzquierdoUnidad, setDataUnidadVistaUnidad, setDataUnidad, setUnidadSeleccionada]);
    console.log("dataUnidad",dataUnidad);
    console.log("unidadSeleccionada",unidadSeleccionada);
    
    // Componentes memoizados
    const memoizedMarkers = useMemo(() => {

        return coordenadasVistaUnidades
            .filter(unidaditem => {
                const isValid = unidaditem.coordenadas &&
                    typeof unidaditem.coordenadas.lat === 'number' &&
                    typeof unidaditem.coordenadas.lng === 'number';

                return isValid;
            })
            .map((unidaditem) => {
                // Convertir objeto {lat, lng} a array [lat, lng] para Leaflet
                const position = [unidaditem.coordenadas.lat, unidaditem.coordenadas.lng];
                let icon = markerUnidadIcono;
                let isHighlighted = false;

                if (dataUnidadVistaUnidad?.UNIDAD == unidaditem?.UNIDAD) {
                    icon = markerUnidadSeleccionadoUnidades;
                    isHighlighted = true;
                }
                if (unidadSeleccionada?.UNIDAD == unidaditem?.UNIDAD) {
                    icon = markerUnidadSeleccionadoUnidades;
                    isHighlighted = true;
                    setDataUnidad(null);
                }


                return (
                    <Marker
                        key={`marker-vista-unidad-${unidaditem.UNIDAD}`}
                        position={position}
                        icon={icon}
                        eventHandlers={{
                            click: () => handleUnidadClick(unidaditem),
                            add: (e) => {
                                // Solo agregar efecto de resplandor sin selected-highlight
                                setTimeout(() => {
                                    const markerElement = e.target._icon;
                                    if (markerElement) {
                                        markerElement.classList.add('marker-glow-effect');
                                    }
                                }, 100);
                            }
                        }}
                        riseOnHover={true}
                        riseOffset={500} // Reducir para evitar conflictos
                        zIndexOffset={500}
                    >
                        {/* <Popup>
                            <div>
                                <h4>Unidad {unidaditem.UNIDAD}</h4>
                                <p>Lat: {unidaditem.coordenadas.lat}</p>
                                <p>Lng: {unidaditem.coordenadas.lng}</p>
                            </div>
                        </Popup> */}
                    </Marker>
                );
            });
    }, [coordenadasVistaUnidades, handleUnidadClick, dataUnidad, unidadSeleccionada]);
    
    return (
        <div className="panel-mapa-container">
            <div className="panel-content">
                <div className="map-container">
                    <Map
                        center={centrarUnidad && centrarUnidad.lat && centrarUnidad.lng ?
                            [centrarUnidad.lat, centrarUnidad.lng] : defaultCenter}
                        zoom={zoom}
                        scrollWheelZoom={true}
                        style={{ height: "100%" }}
                        ref={mapRef}
                        whenReady={() => {
                            console.log('Mapa de vista unidades listo');
                        }}
                    >
                        <CentrarMapa lat={centrarUnidad?.lat} lng={centrarUnidad?.lng} zoom={zoom} />
                        {memoizedMarkers}
                    </Map>
                </div>
            </div>
        </div>
    )
}
export default PanelMapaVistaUnidad;